import { Input } from 'components/2-molecules/Inputs/Input';
import { useState } from 'react';
import styles from './ExciseDutyResult.module.scss';

type ExciseDutyResultProps = {
	container: string;
	unit: string;
	calculator: (ammount: number) => number;
	rateInfo: string;
};

export function formatCurrency(ammount: number): string {
	if (ammount === null || isNaN(ammount)) return null;

	return ammount.toFixed(2).toString().replace('.', ',') + ' kr.';
}

export const ExciseDutyResult: React.FC<ExciseDutyResultProps> = ({ container, unit, calculator, rateInfo }) => {
	const [containerCount, setContainerCount] = useState<number>(1);
	const [containerVolume, setContainerVolume] = useState<number>(null);

	const volumeTotal = (containerCount || 0) * (containerVolume || 0);
	const result = formatCurrency(calculator?.(volumeTotal));

	return (
		<>
			<div className={styles.ExciseDutyResult}>
				<div>
					<label htmlFor="containerCount">{container}</label>
					<Input
						type="number"
						id="containerCount"
						value={containerCount?.toString()}
						onChange={(e) => {
							setContainerCount(e.currentTarget.valueAsNumber);
						}}
					/>
				</div>
				<div>
					<label htmlFor="volume">a {unit}</label>
					<Input
						type="number"
						id="volume"
						value={containerVolume?.toString()}
						onChange={(e) => {
							setContainerVolume(e.currentTarget.valueAsNumber);
						}}
					/>
				</div>
				<div>
					<label htmlFor="total">{unit} i alt</label>
					<Input type="number" id="total" readOnly value={volumeTotal.toString()} />
				</div>
			</div>
			{result ? (
				<>
					<div className={styles.ExciseDutyResult_result}>Afgift i alt: {result}</div>
					<div>
						<p>{rateInfo}</p>
					</div>
				</>
			) : null}
		</>
	);
};
